import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { playersPatchedResponseSchema } from '../types';

export const receivePlayersPatched = createReceive(
	'players-patched',
	zodContract(playersPatchedResponseSchema),
);
